/* Phonetel — interactions légères, sans dépendance */
(function () {
  'use strict';

  /* Une seule question ouverte à la fois dans la FAQ */
  function initFaq() {
    document.querySelectorAll('.pt-faq__list').forEach(function (list) {
      var items = list.querySelectorAll('details.pt-faq__item');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
    });
  }


  /* Onglets de la grille tarifaire */
  function initPriceTabs() {
    document.querySelectorAll('.pt-prices').forEach(function (root) {
      var tabs = root.querySelectorAll('.pt-prices__tab');
      var panels = root.querySelectorAll('.pt-prices__panel');
      if (!tabs.length) return;

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.dataset.ptTab;
          tabs.forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            p.classList.toggle('is-active', p.dataset.ptPanel === target);
          });
        });
      });
    });
  }

  /* Horizon fait défiler .page-wrapper au-dessus de 990 px, et la fenêtre en
     dessous. Plutôt que de deviner lequel est actif — la bascule dépend d'une
     media query qui peut changer à tout moment — on écoute les deux et on
     retient la position la plus avancée. Une seule des deux bouge jamais. */
  /* Teinte du bloc situé sous la barre. Plutôt que de lire une couleur calculée
     — inutilisable dès qu'il y a un dégradé ou une image — on lit la classe que
     la section porte déjà pour se décrire. */
  function toneOfSection(el) {
    if (!el) return 'light';
    var c = el.classList;
    if (c.contains('pt-bg-dark') || c.contains('pt-on-dark')) return 'dark';
    if (c.contains('pt-cta')) return 'dark';
    if (c.contains('pt-pagehead')) return c.contains('pt-pagehead--banner') ? 'dark' : 'light';
    if (c.contains('pt-hero')) return c.contains('pt-on-light') ? 'light' : 'dark';
    if (c.contains('pt-footer')) return c.contains('pt-footer--light') ? 'light' : 'dark';
    return 'light';
  }

  function toneUnderNav(nav) {
    var edge = nav.getBoundingClientRect().bottom + 6;
    var blocks = document.querySelectorAll(
      '.pt-hero, .pt-pagehead, .pt-section, .pt-cta, .pt-footer, .pt-article'
    );

    for (var i = blocks.length - 1; i >= 0; i--) {
      var r = blocks[i].getBoundingClientRect();
      if (r.top <= edge && r.bottom > edge) return toneOfSection(blocks[i]);
    }
    return 'light';
  }

  function initNav() {
    var nav = document.querySelector('[data-pt-nav]');
    if (!nav) return;

    var wrapper = document.querySelector('.page-wrapper');
    var burger = nav.querySelector('.pt-nav__burger');
    var panel = nav.querySelector('.pt-nav__panel');
    var ticking = false;

    function currentY() {
      var a = wrapper ? wrapper.scrollTop : 0;
      var b = window.scrollY || window.pageYOffset || 0;
      return a > b ? a : b;
    }

    var lastY = currentY();

    function panelOpen() {
      return burger && burger.getAttribute('aria-expanded') === 'true';
    }

    function update() {
      var y = currentY();
      var delta = y - lastY;

      nav.classList.toggle('is-scrolled', y > 12);
      nav.classList.toggle('is-on-light', toneUnderNav(nav) === 'light');

      if (y < 90 || panelOpen()) {
        nav.classList.remove('is-hidden');
      } else if (delta > 5) {
        nav.classList.add('is-hidden');
      } else if (delta < -5) {
        nav.classList.remove('is-hidden');
      }

      lastY = y;
      ticking = false;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    if (wrapper) wrapper.addEventListener('scroll', onScroll, { passive: true });
    update();

    if (!burger || !panel) return;

    function close() {
      burger.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
    }

    burger.addEventListener('click', function () {
      var open = panelOpen();
      burger.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.hidden = open;
      if (!open) nav.classList.remove('is-hidden');
    });

    panel.addEventListener('click', function (e) {
      if (e.target.closest('a')) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panelOpen()) { close(); burger.focus(); }
    });

    document.addEventListener('click', function (e) {
      if (panelOpen() && !nav.contains(e.target)) close();
    });
  }

  /* Retour en haut : cible le conteneur qui défile réellement */
  function initBackToTop() {
    var btn = document.querySelector('[data-pt-top]');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var wrapper = document.querySelector('.page-wrapper');
      var smooth = { top: 0, behavior: 'smooth' };
      if (wrapper && wrapper.scrollTop > 0) {
        wrapper.scrollTo(smooth);
      } else {
        window.scrollTo(smooth);
      }
    });
  }

  /* Liens d'ancrage : Horizon fait défiler .page-wrapper au-dessus de 990 px,
     et l'en-tête flottant recouvre le haut de la cible. On gère les deux. */
  function initAnchors() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;

      var id = link.getAttribute('href').slice(1);
      if (!id) return;

      var target = document.getElementById(id);
      if (!target) return;

      e.preventDefault();

      var headerH = parseInt(
        window.getComputedStyle(document.documentElement).getPropertyValue('--pt-header-h'), 10
      ) || 74;
      var offset = headerH + 20;

      var wrapper = document.querySelector('.page-wrapper');
      var oy = wrapper ? window.getComputedStyle(wrapper).overflowY : '';
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var behavior = reduce ? 'auto' : 'smooth';

      if (wrapper && (oy === 'auto' || oy === 'scroll')) {
        var top = wrapper.scrollTop
          + target.getBoundingClientRect().top
          - wrapper.getBoundingClientRect().top
          - offset;
        wrapper.scrollTo({ top: Math.max(top, 0), behavior: behavior });
      } else {
        window.scrollTo({
          top: Math.max(target.getBoundingClientRect().top + window.scrollY - offset, 0),
          behavior: behavior
        });
      }

      if (history.replaceState) history.replaceState(null, '', '#' + id);
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    });
  }

  /* Statut d'ouverture calculé chez le visiteur, à partir des horaires au
     format Google (« Tu-Su 10:00-19:00, Fr 15:00-20:00 »). Le calcul se fait
     côté navigateur : une page mise en cache afficherait sinon un statut faux. */
  var DAYS = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
  var DAY_FR = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];

  function parseHours(spec) {
    var byDay = [[], [], [], [], [], [], []];
    if (!spec) return byDay;

    spec.split(',').forEach(function (chunk) {
      var m = chunk.trim().match(/^([A-Za-z]{2}(?:-[A-Za-z]{2})?)\s+(\d{1,2}):(\d{2})\s*-\s*(\d{1,2}):(\d{2})$/);
      if (!m) return;

      var open = parseInt(m[2], 10) * 60 + parseInt(m[3], 10);
      var close = parseInt(m[4], 10) * 60 + parseInt(m[5], 10);
      var range = m[1].split('-');

      if (range.length === 2) {
        var from = DAYS.indexOf(range[0]);
        var to = DAYS.indexOf(range[1]);
        if (from < 0 || to < 0) return;
        for (var i = 0; i < 7; i++) {
          var d = (from + i) % 7;
          byDay[d].push([open, close]);
          if (d === to) break;
        }
      } else {
        var one = DAYS.indexOf(range[0]);
        if (one >= 0) byDay[one].push([open, close]);
      }
    });

    byDay.forEach(function (slots) { slots.sort(function (a, b) { return a[0] - b[0]; }); });
    return byDay;
  }

  function shopNow(tz) {
    var offset = 0;
    var m = /^([+-])(\d{2})(\d{2})$/.exec((tz || '').trim());
    if (m) offset = (m[1] === '-' ? -1 : 1) * (parseInt(m[2], 10) * 60 + parseInt(m[3], 10));
    var utc = Date.now() + new Date().getTimezoneOffset() * 60000;
    return new Date(utc + offset * 60000);
  }

  function fmtTime(mins) {
    var h = Math.floor(mins / 60), m = mins % 60;
    return m ? h + 'h' + (m < 10 ? '0' + m : m) : h + 'h';
  }

  function initHeroStatus() {
    var hero = document.querySelector('[data-pt-hero]');
    if (!hero) return;

    var box = hero.querySelector('[data-pt-status]');
    var label = hero.querySelector('[data-pt-status-text]');
    if (!box || !label) return;

    var byDay = parseHours(hero.getAttribute('data-hours'));
    var hasAny = false;
    byDay.forEach(function (d) { if (d.length) hasAny = true; });
    if (!hasAny) return;

    var now = shopNow(hero.getAttribute('data-tz'));
    var day = now.getDay();
    var mins = now.getHours() * 60 + now.getMinutes();
    var state = 'closed';
    var text = '';

    var today = byDay[day];
    for (var i = 0; i < today.length; i++) {
      if (mins >= today[i][0] && mins < today[i][1]) {
        var left = today[i][1] - mins;
        state = left <= 60 ? 'soon' : 'open';
        text = left <= 60
          ? 'Ouvert · ferme dans ' + left + ' min'
          : 'Ouvert · ferme à ' + fmtTime(today[i][1]);
        break;
      }
    }

    if (!text) {
      var later = null;
      for (var j = 0; j < today.length; j++) {
        if (today[j][0] > mins) { later = today[j]; break; }
      }
      if (later) {
        text = 'Fermé · ouvre à ' + fmtTime(later[0]);
      } else {
        for (var k = 1; k <= 7; k++) {
          var d = (day + k) % 7;
          if (byDay[d].length) {
            var when = k === 1 ? 'demain' : DAY_FR[d];
            text = 'Fermé · ouvre ' + when + ' à ' + fmtTime(byDay[d][0][0]);
            break;
          }
        }
      }
    }

    if (!text) return;

    label.textContent = text;
    box.setAttribute('data-state', state);
    box.hidden = false;

  }

  /* --------------------------------------------------------------------------
     Conversions
     Le balisage portait déjà des crochets data-pt-track sans rien pour les
     lire. Ici, un seul écouteur délégué traduit les clics qui comptent pour
     une boutique physique — appel, itinéraire, avis, formulaire — en
     évènements Google Analytics et en conversions Google Ads.
     Sans identifiant renseigné, la fonction ne fait rien.
     -------------------------------------------------------------------------- */
  function initTracking() {
    /* Lue à chaque évènement plutôt qu'une fois à l'initialisation : le bloc
       de configuration vit dans le <head>, mais un ordre de chargement
       inattendu ne doit pas figer la mesure à « absente ». */
    function config() { return window.ptTracking; }

    function envoie(nom, emplacement) {
      var cfg = config();
      var debug = cfg && cfg.debug;
      if (debug) console.log('[Phonetel] évènement :', nom, '·', emplacement);
      if (!cfg || typeof window.gtag !== 'function') return;

      if (cfg.ga) window.gtag('event', nom, { emplacement: emplacement });

      var etiquette = '';
      if (nom === 'appel_telephone') etiquette = cfg.labels.appel;
      else if (nom === 'itineraire') etiquette = cfg.labels.itineraire;
      else if (nom === 'contact_envoye') etiquette = cfg.labels.contact;
      else if (nom === 'whatsapp') etiquette = cfg.labels.whatsapp;

      if (cfg.ads && etiquette) {
        window.gtag('event', 'conversion', { send_to: cfg.ads + '/' + etiquette });
        if (debug) console.log('[Phonetel] conversion Ads :', cfg.ads + '/' + etiquette);
      }
    }
    window.ptTrack = envoie;

    document.addEventListener('click', function (e) {
      var cible = e.target;
      if (!cible || typeof cible.closest !== 'function') return;
      var lien = cible.closest('a, button');
      if (!lien) return;

      var href = lien.getAttribute('href') || '';
      var ou = lien.getAttribute('data-pt-track') || 'autre';

      if (href.indexOf('wa.me') > -1 || href.indexOf('api.whatsapp.com') > -1) { envoie('whatsapp', ou); return; }
      if (href.indexOf('tel:') === 0) { envoie('appel_telephone', ou); return; }
      if (href.indexOf('mailto:') === 0) { envoie('courriel', ou); return; }
      /* Le lien d'avis et le lien d'itinéraire pointent tous deux sur Google Maps :
         seul le paramètre cid distingue la fiche de l'itinéraire. */
      if (/maps\.google\.|google\.[a-z.]+\/maps/.test(href)) {
        envoie(href.indexOf('cid=') > -1 ? 'avis_google' : 'itineraire', ou);
      }
    }, true);

    /* Formulaire de contact : le bloc de confirmation n'existe qu'après envoi. */
    if (document.querySelector('[data-pt-track="contact-envoye"]')) {
      envoie('contact_envoye', 'contact');
    }
  }

  /* --------------------------------------------------------------------------
     Bulle WhatsApp
     Révélée après un premier défilement pour ne pas se poser sur le hero.
     Le conteneur défilant dépend de la largeur : on écoute les deux, comme
     pour la barre de navigation.
     -------------------------------------------------------------------------- */
  function initWhatsapp() {
    var bulle = document.querySelector('[data-pt-wa]');
    if (!bulle) return;

    var wrapper = document.querySelector('.page-wrapper');
    var attente = false;

    function y() {
      var a = wrapper ? wrapper.scrollTop : 0;
      var b = window.scrollY || window.pageYOffset || 0;
      return a > b ? a : b;
    }
    function update() {
      bulle.classList.toggle('is-visible', y() > 220);
      attente = false;
    }
    function onScroll() {
      if (attente) return;
      attente = true;
      window.requestAnimationFrame(update);
    }

    if (wrapper) wrapper.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  /* --------------------------------------------------------------------------
     Ruban d'avis : arrêt hors écran
     Une piste de 4 200 px animée en continu reste recomposée à chaque image,
     même quand la section est loin sous le pli. On la met en pause tant
     qu'elle n'est pas en vue. Une classe plutôt qu'un style en ligne, pour ne
     pas écraser la pause au survol.
     -------------------------------------------------------------------------- */
  function initMarquee() {
    var rubans = document.querySelectorAll('.pt-reviews__marquee');
    if (!rubans.length) return;
    if (!('IntersectionObserver' in window)) return;

    var obs = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        e.target.classList.toggle('is-hors-vue', !e.isIntersecting);
      });
    }, { rootMargin: '200px 0px' });

    Array.prototype.forEach.call(rubans, function (r) { obs.observe(r); });
  }

  function init() {
    initNav();
    initHeroStatus();
    initAnchors();
    initBackToTop();
    initPriceTabs();
    initFaq();
    initTracking();
    initWhatsapp();
    initMarquee();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Le thème recharge les sections dans l'éditeur : on réinitialise */
  document.addEventListener('shopify:section:load', init);
})();
